module.exports = __webpack_public_path__ + "media/images/icons/zh-hans-b3e9d3022664e234392eac6a8292a965.png";